import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";

import imcoming_call from '../../../../images/manage_calls/incoming_call.ico';
import missed_call from '../../../../images/manage_calls/missed_call.ico';
import rejected_call from '../../../../images/manage_calls/un_attended_call.ico';

import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';

const Manage_Cloud_Calls = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [yeardisplay, setyeardisp] = useState(new Date());

    const [datas, setData] = useState([]);
    const [responses, setresp] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);
    
    // page table data fetch
    // const fetchData = (filter = {}) => {
    //     const params = {
    //         ...filter,      // spread existing filter key-values
    //         page,           // add page number
    //         per_page: perPage, // add per_page
    //         search: searchTerm  // add search string
    //     };
    //     axios.get(`${baseURL}/appointment`, { params: params })
    //         .then(response => {
    //             setData(response.data.data);
    //             setresp(response.data);
    //             setHasFetched(true);
    //             setTotalPages(response.data.last_page);
    //             setTotslEntries(response.data.total);
    //         })
    //         .catch(error => {
    //             console.log('There was an error fetching the data!', error);
    //             setHasFetched(true);
    //         });
    // };
    // // fetch data & leadstatus
    // useEffect(() => {
    //     fetchData();
    // }, [page, searchTerm, perPage]);


    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);


    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Cloud Call</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Lead Management</li>
                    </ol>
                </div>

                <div class="d-flex align-items-center justify-content-end mb-1">
                    <div class="w-60 mb-1 col-lg-7">
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)}  maxDate={new Date()}/>
                            <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                        </div>
                    </div>
                </div>
            </div>

            <Row className='mb-4'>
                
                <div className="d-flex align-items-center justify-content-lg-between justify-content-center flex-wrap gap-2">
                    <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-0">
                        <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Incoming Calls">
                            <div className="fw-semibold fs-6 text-black text-center">Incoming Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> April </span>)</div>
                            <div>
                                <img src={imcoming_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-block mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Incomming Calls</span> </Tooltip>}>
                                <div className="badge bg-success text-white rounded fw-bold fs-8">01</div>
                                </OverlayTrigger>
                            </div>
                        </div>    
                        
                        <div className="text-center border border-2 p-2 mb-2">
                            <div className="fw-semibold fs-6 text-black text-center">Missed Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> April </span>)</div>
                            <div>
                                <img src={missed_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-flex align-items-center justify-content-center mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Missed Calls</span> </Tooltip>}>
                                <div  className="badge bg-info text-white rounded fw-bold fs-8">00</div>
                                </OverlayTrigger>
                            </div>
                        </div>

                        <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Rejected Calls">
                            <div className="fw-semibold fs-6 text-black text-center">Un-Attended Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> April </span>)</div>
                            <div>
                                <img src={rejected_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-block mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Un-Attended Calls</span> </Tooltip>}>
                                <div  className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#ff0028' }}>00</div>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>

                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Row>
                            <Col xl={12}>
                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{  fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{  fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table style={{ borderBottom: '2px solid #ddd' }} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                                <th className='min-w-90px'>Lead</th>
                                                <th className='min-w-90px text-center'>Lead Status</th>
                                                <th className='min-w-50px'>What</th>
                                                <th className='min-w-100px'>State / Country</th>
                                                <th className='min-w-50px'>Call Date</th>
                                                <th className='min-w-50px'>Start / End Time</th>
                                                <th className='min-w-50px'>Duration</th>
                                                <th className='min-w-50px text-center'>Status</th>
                                                <th className='min-w-20px text-center'>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <div className='mb-0'>
                                                            <label className='text-black font-w400 fs-7'>Thenshidha</label>
                                                            <div className="d-block">
                                                                <div className="fs-8 font-w600 text-dark">9632587415</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="badge bg-success text-black rounded fw-bold fs-8">Active</div>
                                                </td>
                                                <td>
                                                    <div className='d-block'>
                                                        <div className='text-black font-w600 fs-8 text-wrap mw-75'>Call missed by Aarav - Vishnu at (Enquire)</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7  mw-75'>TN, IN</div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7  mw-75'>07-Jul-2025</div>
                                                </td>
                                                <td>
                                                    <label class="fs-7 font-w400 text-info fw-semibold">01:24:19 PM</label>
                                                    <div class="d-block">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">End time</span> </Tooltip>}>
                                                        <label class="text-danger fw-semibold fs-7 font-w400">01:25:50 PM</label>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7 mw-75'>00:01:31</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="badge bg-success text-black rounded fw-bold fs-8">Outgoing Call</div>
                                                </td>
                                                <td>
                                                    <div className="text-center">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Location</span> </Tooltip>}>
                                                            <Button
                                                                variant="primary tp-btn-light px-2 py-1 me-1"
                                                            >
                                                                <span>
                                                                    <i class="fa-solid fa-download fs-4 mt-1"></i>
                                                                </span>
                                                            </Button>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <div className='mb-0'>
                                                            <label className='text-black font-w400 fs-7'>Thenshidha</label>
                                                            <div className="d-block">
                                                                <div className="fs-8 font-w600 text-dark">9632587415</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="badge bg-success text-black rounded fw-bold fs-8">Active</div>
                                                </td>
                                                <td>
                                                    <div className='d-block'>
                                                        <div className='text-black font-w600 fs-8 text-wrap mw-75'>Call missed by Aarav - Vishnu at (Enquire)</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7  mw-75'>TN, IN</div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7  mw-75'>07-Jul-2025</div>
                                                </td>
                                                <td>
                                                    <label class="fs-7 font-w400 text-info fw-semibold">01:24:19 PM</label>
                                                    <div class="d-block">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">End time</span> </Tooltip>}>
                                                        <label class="text-danger fw-semibold fs-7 font-w400">01:25:50 PM</label>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7 mw-75'>00:01:31</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="badge bg-success text-black rounded fw-bold fs-8">Outgoing Call</div>
                                                </td>
                                                <td>
                                                    <div className="text-center">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Location</span> </Tooltip>}>
                                                            <Button
                                                                variant="primary tp-btn-light px-2 py-1 me-1"
                                                            >
                                                                <span>
                                                                    <i class="fa-solid fa-download fs-4 mt-1"></i>
                                                                </span>
                                                            </Button>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <div className='mb-0'>
                                                            <label className='text-black font-w400 fs-7'>Thenshidha</label>
                                                            <div className="d-block">
                                                                <div className="fs-8 font-w600 text-dark">9632587415</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="badge bg-success text-black rounded fw-bold fs-8">Active</div>
                                                </td>
                                                <td>
                                                    <div className='d-block'>
                                                        <div className='text-black font-w600 fs-8 text-wrap mw-75'>Call missed by Aarav - Vishnu at (Enquire)</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7  mw-75'>TN, IN</div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7  mw-75'>07-Jul-2025</div>
                                                </td>
                                                <td>
                                                    <label class="fs-7 font-w400 text-info fw-semibold">01:24:19 PM</label>
                                                    <div class="d-block">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">End time</span> </Tooltip>}>
                                                        <label class="text-danger fw-semibold fs-7 font-w400">01:25:50 PM</label>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7 mw-75'>00:01:31</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="badge bg-success text-black rounded fw-bold fs-8">Outgoing Call</div>
                                                </td>
                                                <td>
                                                    <div className="text-center">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Location</span> </Tooltip>}>
                                                            <Button
                                                                variant="primary tp-btn-light px-2 py-1 me-1"
                                                            >
                                                                <span>
                                                                    <i class="fa-solid fa-download fs-4 mt-1"></i>
                                                                </span>
                                                            </Button>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ):(
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>

                                        {/* Bottom right: Pagination */}
                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                </li>
                                                {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                </li>
                                                ))}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                </li>
                                            </ul>
                                        </nav>

                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>

            </Row>
        </>
    )


}
export default Manage_Cloud_Calls;